<form>
  <input type="text" #input (keyup)="search(input.value)" placeholder="Buscar Pokemon...">
  <img src="assets/icons/search.svg" alt="Buscar Pokemon">
</form>
